import $ from 'jquery';
import {BaseHandler} from "./BaseHandler";
import {EmailReport} from "../Api/Types";
import {Popup} from "../Popups/Popup";
import {NavigableTable} from "./NavigableTableHandler";

export class SentEmailReportsHandler extends BaseHandler {

    private navigableTable: NavigableTable<EmailReport>

    private buildRow(e: EmailReport):JQuery<HTMLTableRowElement> {
        const table = $('#sent-mail-rep');
        const row = this.get_template_jquery<HTMLTableRowElement>("sent-email-report-row-template")
        row.find('[data-content-type="mail_report_id"]').text(e.email_report_id);
        row.find('[data-content-type="report_date"]').text(this.format_date(e.report_date));
        row.find('[data-content-type="payments_no"]').text(e.payments_no);

        row.find(e.all_ok ? '[data-when="all_ok"]' : '[data-when="not_all_ok"]').show();

        row.find('[data-action="download"]').on("click", () => this.download(e.zip_download_url))
        row.find('[data-action="details"]').on("click", () => {
            const dom = e.domCacheLookUp(() => {
                const wp = this.get_template_jquery("sent-email-report-details-template");
                const tbody = wp.find("tbody");
                for (const i of e.email_status) {
                    const row = this.get_template_jquery("sent-email-report-details-row-template");
                    row.find('[data-content-type="name"]').text(i.name);
                    row.find('[data-content-type="email"]').text(i.email);

                    row.find(i.ok ? '[data-when="ok"]' : '[data-when="not_ok"]').show();

                    tbody.append(row)
                }

                return wp;
            })

            Popup.DirectInject(dom, this.get_template_text("details-popup-title"), true, true).popup.SetShowActions(false);
        })

        table.append(row);
        return row;

    }

    private get_reports(dropped: boolean = false) {
        if (dropped) this.navigableTable.drop_from_current();
        else this.navigableTable.drop_cache();
        this.navigableTable.update();
    }

    public override handle() {
        super.handle();
        const tableWrapper = $('#table-wrapper-sent-email-reports');
        this.navigableTable = new NavigableTable(tableWrapper, e => {
            return this.buildRow(e)
        }, (page_index, items_per_page) => {
            return this.client.get_email_reports(items_per_page, page_index);
        });
        this.get_reports();
    }
}